import { GET_BULK_USERS, GET_BULK_USERS_SUCCESS, GET_BULK_USERS_ERROR, GET_BULK_USERS_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBulkUsers = (state = initialState, action) => {
  switch (action.type) {
    case GET_BULK_USERS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BULK_USERS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BULK_USERS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BULK_USERS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBulkUsers;
